import { render, staticRenderFns } from "./FacilityCapacity.vue?vue&type=template&id=20500228&"
import script from "./FacilityCapacity.vue?vue&type=script&lang=js&"
export * from "./FacilityCapacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports